import { SC } from "../helper/ServerCall";

export const contactService = {
    saveCustomerContact,
    getContactsPagination,
    getContactItem,
    editCustomerContact,
    deleteContact,
    getCustomerAllContacts
};

function saveCustomerContact(data) {
    return SC.postCall(`contact`, data);
}

function getCustomerAllContacts() {
    return SC.getCall(`contacts/get-customer-contacts`);
}

function getContactsPagination(
    id,
    model,
    filter,
    page,
    sort,
    pageSize,
    component_name,
    pagination
) {
    return SC.getCall(
        "contact?model_id=" +
        id +
        "&model=" +
        model +
        "&filter=" +
        filter +
        "&page=" +
        page +
        "&sort=" +
        sort +
        "&pageSize=" +
        pageSize +
        "&component_name=" +
        component_name +
        "&paginate=" +
        pagination
    );
}

function getContactItem(id) {
    return SC.getCall(`contact/${id}`);
}

function editCustomerContact(data, id) {
    return SC.putCall("contact/" + id, data);
}

function deleteContact(id) {
    return SC.deleteCall("contact/" + id);
}



// WEBPACK FOOTER //
// ./src/services/contact.js